<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="indigo">view_list</v-icon>
            到款基本信息
            <v-spacer/>
        </v-card-title>
        <v-divider color="indigo"/>
        <v-card-text class="pt-0">
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm4 lg4>
                        <div class="x-text-field">
                            <label>凭证内码</label>
                            <div>{{item.pznm}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4 lg4>
                        <div class="x-text-field">
                            <label>分录编号</label>
                            <div>{{item.flbh}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>科目编号</label>
                            <div>{{item.kmbh}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>部门编号</label>
                            <div>{{item.bmbh}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>项目编号</label>
                            <div>{{item.xmbh}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>对冲号</label>
                            <div>{{item.dch}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm12>
                        <div class="x-text-field">
                            <label>摘要</label>
                            <div>{{item.zy}}</div>
                        </div>
                    </v-flex>


                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>责任人</label>
                            <div>{{item.zrr}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>金额</label>
                            <div>{{item.je}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>凭证编号</label>
                            <div>{{item.pzbh}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm12>
                        <div class="x-text-field">
                            <label>对方单位</label>
                            <div>{{item.dfdw}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>凭证日期</label>
                            <div>{{item.pzrq}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>来款类型名称</label>
                            <div>{{ properties[item.lxbh] }}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>制单人</label>
                            <div>{{item.zdr}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <div class="x-text-field">
                            <label>认款人</label>
                            <div>{{item.claimName}}</div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "basic",
        props: {
            incoBasic: Object
        },

        data: () => ({
        item: {},
        properties: {
            "01": '银行来款',
            "02": '科研来款',
            "03": '其它来款'
        },
        flagMaps: {
            "0": '未认领',
            "1": '已认领'
        },
    }),

    watch: {
        incoBasic(v) {
            if (v) this.item = v;
        }
    },
    computed: {
    },
    methods: {
    }
    }
</script>

<style scoped>

</style>